import axios from 'axios';

export const iniciarCaptchaAfip = async () => {
  try {  
    //  const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/captcha/iniciarCaptchaAfip`); 
    const response = await axios.get(`/api/captcha/iniciarCaptchaAfip`);       
    return response.data;
  } catch (error) {
    console.error('Error iniciando captcha:', error);
    throw error;
  }
};

export const postCaptchaSolution = async (solution, token) => {
    try {
      const response = await axios.post(
        // `${process.env.REACT_APP_API_URL}/api/captcha/postCaptchaSolution`,
        `/api/captcha/postCaptchaSolution`,
        { solution, token },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );      
      return response.data;
      
    } catch (error) {
      console.error('Error enviando solución captcha:', error);
      throw error;
    }
  };
  

